import { useCallback, useMemo, useState } from 'react'
import { useSuspenseQuery } from '@apollo/client'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'
import { isSuccessReturn } from '@guestgoodie/auth-core'
import { useLingui } from '@lingui/react/macro'

import { useAuth } from '@/features/auth'
import { showToast, ToastType } from '@/features/toast'

export function useCurrentUser() {
  const { t } = useLingui()
  const { resetPassword: defaultResetPassword } = useAuth()
  const { data } = useSuspenseQuery(AdminAPI.user.ME)

  const [isResetLoadig, setIsResetLoading] = useState(false)

  const user = useMemo(
    () => getFragment(SharedAPI.user.USER_FRAGMENT, data.me),
    [data]
  )

  const resetPassword = useCallback(() => {
    setIsResetLoading(true)

    defaultResetPassword(user.email)
      .then(response => {
        if (response && isSuccessReturn(response)) {
          showToast({
            id: 'change-password-request-success',
            type: ToastType.SUCCESS,
            message: t({
              comment:
                'Success toaster message when a user requested a email to reset their password.',
              message: 'We send you an email to reset your password.'
            })
          })

          return
        }

        showToast({
          id: 'change-password-request-error',
          type: ToastType.ERROR,
          message: t({
            comment:
              'Error toaster message when a user requested a email to reset their password.',
            message:
              'There was a problem sending an email to you, please try again or if this keeps happening, write our support.'
          })
        })
      })
      .finally(() => {
        setIsResetLoading(false)
      })
  }, [user.email, setIsResetLoading, defaultResetPassword, t])

  return { user, isResetLoadig, resetPassword }
}
